import { NgModule } from '@angular/core';
import { CommonModule, OfferCalculatorDetailsTableModule, OfferCalculatorPaymentScheduleModule, OfferDrawSliderModule } from 'common';
import { LineOfCreditContentComponent } from './line-of-credit-content.component';
import { MatSliderModule } from '@angular/material/slider';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ShareOfferModule } from '../share-offer/share-offer.module';
import { CalculatorClosingRequirementsModule } from '../calculator-closing-requirements/calculator-closing-requirements.module';
import { LinkYourBankModule } from '../link-your-bank/link-your-bank.module';

@NgModule({
  imports: [
    CommonModule,
    MatSliderModule,
    FlexLayoutModule,
    ShareOfferModule,
    CalculatorClosingRequirementsModule,
    LinkYourBankModule,
    OfferCalculatorDetailsTableModule,
    OfferDrawSliderModule,
    OfferCalculatorPaymentScheduleModule
  ],
  declarations: [
    LineOfCreditContentComponent,
  ],
  exports: [
    LineOfCreditContentComponent,
  ],
  providers: [
    PercentPipe,
    CurrencyPipe
  ]
})
export class LineOfCreditContentModule { }
